/* eslint-disable new-cap */
import $ from 'jquery';
import Tingle from 'tingle.js';
import Base from '../../../_config/base';

class SearchNav extends Base {
  constructor(el) {
    super(el);

    // Get jQuery object
    this.SearchNav = this.$el;

    this.menuHamburger = this.SearchNav.find('.search-nav-toggle');
    this.menuHamburger.bind('click', this.modalClicked.bind(this));

    this.Modal = new Tingle.modal({
      footer: false,
      stickyFooter: false,
      closeMethods: ['overlay', 'escape'],
      cssClass: ['search-nav-modal'],
      onOpen: this.handleModalOpen.bind(this),
      onClose: this.handleModalClose.bind(this),
    });
  }

  handleModalOpen() {
    this.menuHamburger.addClass('btn--active');
    this.menuIsOpen = true;
    this.initModalButtons();
  }

  handleModalClose() {
    this.menuIsOpen = false;
    this.menuHamburger.removeClass('btn--active');
  }

  modalClicked(e) {
    e.preventDefault();

    if (!this.menuIsOpen) {
      // Show navigation menu (modal)
      this.Modal.setContent(this.SearchNav.find('.hidden-nav-content').html());

      const closeBtn = this.SearchNav.find('.search-nav-modal .search-nav-close');
      closeBtn.bind('click', this.closeModal.bind(this));
      this.Modal.open();
    } else {
      this.Modal.close();
    }
  }

  closeModal(e) {
    e.preventDefault();
    this.Modal.close();
  }

  initModalButtons() {
    this.showAllBtn = this.SearchNav.find('.search-nav-modal .nav-section-items-show-all');
    this.showAllBtn.bind('click', this.showAllItems.bind(this));
  }

  showAllItems(e) {
    e.preventDefault();
    e.stopPropagation();

    $(e.target).closest('.header__nav-section').toggleClass('show-all');
    if ($(e.target).closest('.header__nav-section').hasClass('show-all')) {
      $(e.target).closest('.nav-section-items-show-all').find('.header__nav-section-item-title').text('Show Less');
    } else {
      $(e.target).closest('.nav-section-items-show-all').find('.header__nav-section-item-title').text('Show All');
    }
  }
}
/* eslint-enable new-cap */

SearchNav.className = 'SearchNav';
export default SearchNav;



// WEBPACK FOOTER //
// ./src/materials/molecules/search-nav/search-nav.js